import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {EventItem, Lookups, RaceCommercialItem, Race, RaceCommercialItemPeriod} from "@model";
import {TooltipPosition} from "../tooltip/tooltip.enums";

@Component({
    selector: 'app-race-pricing-table',
    templateUrl: './race-pricing-table.component.html',
    styleUrls: ['./race-pricing-table.component.scss'],
    standalone: false
})
export class RacePricingTableComponent extends AbstractComponent implements OnInit {
  @Input() raceCommercialItem: RaceCommercialItem | undefined;
  @Input() event: EventItem | undefined;
  @Input() race: Race | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() currencyLabel?: string;

  items: number[] = [1, 2, 3, 4, 5, 6];
  pageSize = 3;
  periods: RaceCommercialItemPeriod[] = []

  breakpoints = {
    1400: {slidesPerView: 3, spaceBetween: 0},
    992: {slidesPerView: 3, spaceBetween: 0},
    767: {slidesPerView: 2, spaceBetween: 0},
    320: {slidesPerView: 1, spaceBetween: 0}
  };

  constructor() {
    super();
  }

  ngOnInit() {
    this.init()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['race']?.currentValue !== changes['race']?.previousValue ||
      changes['event']?.currentValue !== changes['event']?.previousValue
      ||
      changes['raceCommercialItem']?.currentValue !== changes['raceCommercialItem']?.previousValue) {
      this.init();
    }
  }

  init() {
    this.initPeriods();

  }

  initPeriods(): void {
    this.periods = []
    if (this.raceCommercialItem?.priceConstantByPeriod) {
      this.periods.push(new RaceCommercialItemPeriod(undefined, this.race?.registrationStart, this.race?.registrationEnd, this.raceCommercialItem.price))
    } else {
      this.periods = this.raceCommercialItem?.periods ? [...this.raceCommercialItem!.periods] : []
    }
  }

  trackByFn(index: number, item: RaceCommercialItemPeriod) {
    return item.id;
  }

  protected readonly TooltipPosition = TooltipPosition;
}
